import React, {ReactElement, useState} from 'react';
import {RouteComponentProps} from 'react-router-dom';

import {useEffectOnce} from 'react-use';

import {AppState} from '../../state-management/app';


interface ProtectedProps extends RouteComponentProps, Pick<AppState, 'user'> {
  children: ReactElement | ReactElement[]
}


const Protected = ({user, history, children, location}: ProtectedProps) => {
  const [canRender, setCanRender] = useState(false);

  useEffectOnce(() => {

    if (user) {
      setCanRender(true);
      return
    }

    history.push(`/${location.search}`)
  });

  return <>{canRender && children}</>
};

export default Protected;
